import { usaStates } from "../../../components/ui/forms/selectOptionData";

export function toStateCode(value) {
  const v = (value || "").trim();
  if (!v) return "";
  if (v.length === 2) return v.toLowerCase();
  const match = usaStates().find(
    (o) =>
      (o.label || "").toLowerCase() === v.toLowerCase() ||
      (o.value || "").toLowerCase() === v.toLowerCase()
  );
  return (match?.value || v).toLowerCase();
}

export function normalizeForCompare(addr) {
  return {
    address: (addr?.address || "").trim().toLowerCase(),
    suiteAddress: (addr?.suiteAddress || "").trim().toLowerCase(),
    city: (addr?.city || "").trim().toLowerCase(),
    stateAddress: toStateCode(addr?.stateAddress),
    zipCode: (addr?.zipCode || "").trim().toLowerCase(),
    country: (addr?.country || "US").trim().toLowerCase(),
  };
}

export function zipEquals(a, b) {
  const five = (z) =>
    String(z || "")
      .trim()
      .slice(0, 5);
  return five(a) === five(b);
}

export function areEquivalent(user, suggested) {
  const u = normalizeForCompare(user);
  const s = normalizeForCompare(suggested);
  return (
    u.address === s.address &&
    u.suiteAddress === s.suiteAddress &&
    u.city === s.city &&
    u.stateAddress === s.stateAddress &&
    zipEquals(u.zipCode, s.zipCode)
  );
}

export function buildGoogleRequest(addr) {
  return {
    address: {
      regionCode: addr.country || "US",
      addressLines: [addr.address || "", addr.suiteAddress || ""],
      locality: addr.city || "",
      administrativeArea: addr.stateAddress || "",
      postalCode: addr.zipCode || "",
    },
  };
}

export function mapSuggestedToRHF(
  formMethods,
  fields,
  suggested,
  options = {}
) {
  const normalizedState = toStateCode(suggested?.stateAddress);
  const { consolidatedField } = options || {};

  formMethods.setValue(fields.address, suggested?.address || "", {
    shouldValidate: true,
    shouldDirty: true,
  });
  if (fields.suiteAddress) {
    formMethods.setValue(fields.suiteAddress, suggested?.suiteAddress || "", {
      shouldValidate: false,
      shouldDirty: true,
    });
  }
  formMethods.setValue(fields.city, suggested?.city || "", {
    shouldValidate: true,
    shouldDirty: true,
  });
  formMethods.setValue(fields.stateAddress, normalizedState || "", {
    shouldValidate: true,
    shouldDirty: true,
  });
  formMethods.setValue(fields.zipCode, suggested?.zipCode || "", {
    shouldValidate: true,
    shouldDirty: true,
  });

  if (consolidatedField) {
    formMethods.setValue(
      consolidatedField,
      {
        address: suggested?.address || "",
        suiteAddress: suggested?.suiteAddress || "",
        city: suggested?.city || "",
        stateAddress: normalizedState || "",
        country: suggested?.country || "US",
        zipCode: suggested?.zipCode || "",
        fromDate: "",
        toDate: "",
      },
      { shouldValidate: false, shouldDirty: true }
    );
  }

  return normalizedState;
}
